import { useQuery } from "@tanstack/react-query"
import { api } from "@/services/api"

export default function useLoginByToken(token: string) {
  const query = useQuery({
    queryKey: ["login-by-token", token],
    queryFn: async () => {
      const userInfo = await api.cronos.user.info.get(token)
      const user = userInfo.data.description.user

      const coursesInfo = await api.cronos.courses.getByToken(token)
      const courses = coursesInfo.data.description.courses

      return {
        user,
        courses,
      }
    },
    refetchOnWindowFocus: false,
  })

  return query
}
